export default "__VITE_ASSET__BGZpq9Vw__"